import * as Yup from 'yup';

const editDetailsValidationSchema = Yup.object().shape({
  title: Yup.string()
    .required('Please enter idea title')
    .trim()
    .test('word-count', 'Idea title should not exceed 50 words', (value) => {
      if (!value) return true; // If value is empty, validation passes
      const wordCount = value.trim().split(/\s+/).length;
      return wordCount <= 50;
    })
    .test('invalid-title', 'Please enter a valid title', (value) => {
      if (!value) return true; // If value is empty, let the required validation handle it
      return value.trim() !== 'Title that best reflects your idea';
    }),
  domain: Yup.string().required('Please select a domain'),
  // Keep description validation but comment out since it's not in use currently
  description: Yup.string().optional()
});

export default editDetailsValidationSchema;
